export const salePointsPromise = $.get('/ajax/get-sale-points').promise();



// WEBPACK FOOTER //
// resources/assets/src/js/promises.js